module.exports = __webpack_public_path__ + "static/media/costa-rica.f6a1319c.svg";